// import qs from 'qs'
import request from '@/utils/request'

import config from '@/config/index';

const urls = {
  'gettoken': `${config.HOST_API}${config.BASE_API_PREFIX}/uploadtoken`
}

/**
 * 文件上传前 到服务端获取七牛的上传token
 *
 * @param filename 文件名称
 * @param request
 * @return
 */
function uploadtoken(params) {
  return request({
    url: urls['gettoken'],
    method: 'get',
    params: params
  })
}

import * as qiniu from 'qiniu-js'
// token 找后端，obj 这里指代从 el-upload 接收到的 object
const upload = (fname, token, obj, next, error, complete) => {
  const {
    file
  } = obj
  // 关于 key 要怎么处理自行解决，但如果为 undefined 或者 null 会使用上传后的 hash 作为 key.
  const key = fname // dtime(new Date().getTime()).format('YYYY-MM-DD')
  // 因人而异，自行解决
  const putExtra = {
    fname: '',
    params: {},
    mimeType: null
  }
  //       fname: string，文件原文件名
  // params: object，用来放置自定义变量
  // mimeType: null || array，用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
  const config = {
    useCdnDomain: true
  }
  // let options = {
  //     quality: 0.92,
  //     noCompressIfLarger: true,
  //     maxWidth: 1000,
  //     maxHeight: 618
  // }
  const observable = qiniu.upload(file, key, token, putExtra, config)
  const subscription = observable.subscribe(next, error, complete)
  return subscription
}

export { upload, uploadtoken }
